
import {timer as observableTimer,  Observable, Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { UserProfileService, RvrsService, dropdownMenuInfo } from '../../../core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';

import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-rs-grid',
  templateUrl: './rs-grid.component.html',
  styleUrls: ['./rs-grid.component.scss']
})

export class RsGridComponent implements OnInit, OnDestroy, AfterContentInit {
  public view:GridDataResult;
  public state: State = {
    skip: 0,
    take: 10
  };
  public sorted: string = "";
  public openBtnRateIntegrity: boolean;
  showReportDialog:boolean = false;
  reportDlgAuditId:string = "";
  openChart: boolean = false;
  chartData: any;
  subtitle: string = 'Reverse Audit';
  universalAuditID: string = '0';
  component: string = 'RVRS';
  subscriptions: Subscription[] = [];

  public auditCreateMapping:Array<dropdownMenuInfo> = [
    { text: 'Create From Rate Audit', path:"../createFromRateAudit"},
    { text: 'Import Rate Audit File', path:"../importFromRateAuditFile"},
    { text: 'Manually Build Reverse Audit', path:"../manuallyBuildRateAudit"}
  ]


  constructor( private service: RvrsService, private userProfileService: UserProfileService)
  {
    this.service.getReverseAuditGridData(this.state)
      .subscribe(data=>{
      this.view=data;
    });
  }


  ngOnInit() {
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngAfterContentInit() {

    let timer = observableTimer(1000, 20000);
    const s1 = timer.subscribe(t => {
      if(this.showReportDialog)
        return;
      this.refreshGrid();
    });

    this.subscriptions.push(s1);
  }


  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.refreshGrid();
  }
  refreshGrid(){
    this.sorted = "";
    this.sorted = (this.state.sort && this.state.sort.find(e =>  e.dir==='asc' ||e.dir=='desc' ) || {'field':''}).field;
    this.service.getReverseAuditGridData(this.state)
      .subscribe(data=>{
        this.view=data;
      }
      , err => {
        this.userProfileService.ProcessWebApiServiceErrorResponse(err);
        });
  }

  displayChart(event, item) {
    event.preventDefault();

    this.service.GetRvrsAuditChart(item.AuditRvrID).subscribe(data => {
      this.chartData = data;
      this.universalAuditID = item.UniversalAuditID;
      this.openChart = true;
    });
  }

  closeChartModals() {
    this.openChart = false;
  }
  onTemplateClick(e){
    e.target.parentNode.click()
  }
  onShowReports(auditId: string) {
    this.showReportDialog = true;
    this.reportDlgAuditId = auditId;
  }
  reportDialogDone() {
    this.showReportDialog = false;
  }
}
